import { useEffect, useState } from "react"
//***** Interfaces *****
import {PractitionerOfficeI}  from "@interfaces/practititoner/offices"

// ***** Sevices *****
import { getPractitionerOfficesByUsername } from "@services/offices/offices"


const useOfficesByPractitioner = (practitionerUsername: string, organizationId: number, isOwner: boolean) => {
    const [offices, setOffices] = useState<PractitionerOfficeI[] | null>(null)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        loadData()
     // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [practitionerUsername, organizationId, isOwner])

    const loadData = () => {
        if (practitionerUsername === "") {
            console.debug("practitionerUsername is empty")
            return
        }
        console.debug("practitionerUsername: ", practitionerUsername)

        getPractitionerOfficesByUsername(practitionerUsername, organizationId, isOwner)
            .then((data) => {
                setOffices(data)
            })
            .catch(err => {
                console.error("Could not retrieve offices", err)
                setError(err)
                setOffices([])
            })
    }

    return { offices, error, reload: loadData }
}

export default useOfficesByPractitioner